<form [formGroup]="form">
  <div formArrayName="list">
    @for (option of list; track option; let i = $index) {
      <div [formGroupName]="i">
        <div class="form-group custom-control custom-checkbox">
          <input formControlName="checked" type="checkbox" class="custom-control-input" id="i-{{ i }}" />
          <label class="custom-control-label" for="i-{{ i }}">{{ option.text }}</label>
        </div>
      </div>
    }
  </div>
</form>

<!-- <form [formGroup]="form">
<gcc-radio-group name="id" formControlName="selected">
  <div *ngFor="let option of options; let i = index">
    <gcc-radio-button [id]="option.id" [value]="option.id">{{ option.text }}</gcc-radio-button>
  </div>
  <gcc-radio-button [id]="-1" [value]="-1">Other</gcc-radio-button>
</gcc-radio-group>
</form> -->
